import { ModuleConfig } from "@core/interfaces";

const config: ModuleConfig = {
  name: "Busk",
  baseUrl: "",
  routes: [
    {
      path: "/admin/busk/logistic",
      page: "BuskWarehouse",
      title: "Busk Admin warehouse",
      exact: true,
    },
  ],
  requireAuthenticated: true,
};

export default config;
